;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { browserLogger } from 'src/core/logger/browser'
import z from 'zod'

const loaderPropsSchema = z.object({
  src: z
    .string()
    .min(1, 'src must be a non-empty string')
    .url('src must be a valid URL'),
  width: z.number().positive('width must be positive'),
  quality: z
    .number()
    .min(1, 'quality must be ≥ 1')
    .max(100, 'quality must be ≤ 100')
    .optional(),
})

type LoaderProps = z.infer<typeof loaderPropsSchema>

export default function cloudflareLoader({ src, width, quality }: LoaderProps) {
  const parsedParams = loaderPropsSchema.safeParse({ src, width, quality })
  if (!parsedParams.success) {
    browserLogger.error('Invalid Cloudflare loader props', {
      zodError: parsedParams.error.flatten(),
      loaderProps: {
        src,
        width,
        quality,
      },
    })
  }

  const params = [`width=${width}`, `quality=${quality || 75}`, 'format=auto']
  // Percent-encode the commas in the Cloudflare options segment.
  // A lot of crawlers / HTML rewriters / naive link-extractors split on commas and end up “discovering” a fake URL that starts at the last chunk
  // More info: https://qogita.slack.com/archives/C07QHL5EDPZ/p1766414830987729
  return `https://qogita.com/cdn-cgi/image/${params.join(encodeURIComponent(','))}/${src}`
}
